import { axiosPublic } from './common/axiosPublic';
import { axiosPrivate } from './common/axiosPrivate';
import { getQueryParams, handleResponse, handleError } from '../../helpers/network';

export const list = async ({ filter = '', category = '', page = 1, size = 10 }) => {
    const params = getQueryParams({ filter, category, page, size });
    return axiosPublic.get(`/products?${params}`).then(handleResponse).catch(handleError);
};

export const get = async (id) => {
    return axiosPublic.get(`/products/${id}`).then(handleResponse).catch(handleError);
};

export const create = async (item) => {
    return axiosPrivate.post(`/products`, item).then(handleResponse).catch(handleError);
};

export const update = async (item) => {
    return axiosPrivate.put(`/products/${item.id}`, item).then(handleResponse).catch(handleError);
};

export const remove = async (id) => {
    return axiosPrivate.delete(`/products/${id}`).then(handleResponse).catch(handleError);
};
